@if (isLoading) {
  <main class="flex min-h-[520px] flex-1 items-center justify-center px-10 py-6 text-lWhite">
    <l-spinner />
  </main>
} @else if (course) {
  <main class="relative z-10 flex h-[calc(100dvh-6rem)] min-h-0 flex-1 flex-col overflow-hidden px-6 pb-4 pt-2 text-lWhite md:px-10 lg:px-14">
    <section class="flex shrink-0 items-center justify-between gap-4">
      <h1 class="text-3xl font-semibold tracking-tight md:text-4xl lg:text-5xl">{{ course.title }}</h1>

      <l-progress-ring [progress]="userCourseProgress" />
    </section>

    <hr class="my-3 shrink-0 border-lWhite/10" />

    <section class="flex min-h-0 flex-1 gap-3 overflow-hidden">
      <l-sidebar
        [title]="moduleTitle"
        [progress]="selectedModuleProgress"
        [courseProgress]="userCourseProgress"
        [lessons]="lessons"
        [modules]="modules"
        [selectedModuleId]="selectedModuleId"
        [selectedLessonId]="selectedLessonId"
        [hasAssessment]="hasAssessmentInSelectedModule"
        [assessmentScoreText]="assessmentScoreText"
        (lessonSelected)="onLessonSelected($event)"
        (assessmentSelected)="onAssessmentSelected()"
        (moduleSelected)="onModuleSelected($event)"
        (certificateSelected)="onCertificate()"
        (certificateDownloadSelected)="onCertificate()"
      />

      <article class="relative flex min-h-0 flex-1 flex-col overflow-hidden rounded-[18px] bg-transparent text-lWhite">
        @if (isContentLoading) {
          <div class="grid h-full min-h-[330px] place-items-center px-6 text-center text-lWhite/75">
            <l-spinner />
          </div>
        } @else if (selectedContent) {
          <div class="h-full min-h-0 overflow-y-auto">
            @if (isVideoContent(selectedContent)) {
              <l-content-video
                [content]="selectedContent"
                [classId]="progressClassId"
                [resumePosition]="selectedResumePosition"
                (progressChange)="onContentProgress($event)"
                (positionChange)="onContentPosition($event)"
              />
            } @else if (isHtmlContent(selectedContent)) {
              <l-content-html
                [urlPath]="selectedContent.urlPath ?? ''"
                [entrypoint]="selectedContent.entrypoint ?? ''"
                [htmlContent]="selectedContent.htmlContent ?? ''"
              />
            } @else if (isRichTextContent(selectedContent)) {
              <l-content-rich-text
                [mdContent]="richTextBody"
                [classId]="progressClassId"
                [resumePosition]="selectedResumePosition"
                (progressChange)="onContentProgress($event)"
                (positionChange)="onContentPosition($event)"
              />
            } @else if (isPdfContent(selectedContent)) {
              <l-content-pdf class="h-full" [fileUrl]="selectedContent.fileUrl" />
            } @else if (isActivityContent(selectedContent)) {
              <l-content-activity
                [activity]="selectedContent"
                [userId]="currentUserId"
                [classId]="selectedActivityClassId"
                [isLastModule]="isLastModule"
                [isCourseComplete]="isCourseComplete"
                [isCompletingCourse]="isCompletingCourse"
                (submitted)="onActivitySubmitted($event)"
                (restart)="onRestartModule($event)"
                (nextModule)="onNextModule()"
                (certificate)="onCertificate()"
                (completeCourse)="onCompleteCourse()"
              />
            } @else {
              <div class="grid h-full min-h-[330px] place-items-center px-6 text-center text-lWhite/75">
                <p>Tipo de conteúdo não suportado.</p>
              </div>
            }
          </div>
        } @else {
          <div class="grid h-full min-h-[330px] place-items-center px-6 text-center text-lWhite/75">
            <p>Selecione uma aula para visualizar o conteúdo.</p>
          </div>
        }
      </article>
    </section>
  </main>
} @else {
  <main class="flex min-h-[520px] flex-1 flex-col items-center justify-center px-10 py-6 text-center text-lWhite">
    <h1 class="text-3xl font-semibold">Conteúdo não encontrado</h1>
    <p class="mt-3 max-w-md text-lWhite/70">
      Não foi possível localizar o conteúdo do curso solicitado.
    </p>
  </main>
}
